module.exports = __webpack_public_path__ + "static/media/amenity_kitchen.a76d64dd.jpg";